import { render } from "./exam.vue?vue&type=template&id=62bc940a&scoped=true"
import script from "./exam.vue?vue&type=script&lang=js"
export * from "./exam.vue?vue&type=script&lang=js"

import "./exam.vue?vue&type=style&index=0&id=62bc940a&lang=css"
import "./exam.vue?vue&type=style&index=1&id=62bc940a&lang=scss&scoped=true"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62bc940a"]])

export default __exports__